import { render, staticRenderFns } from "./ShowHuman.vue?vue&type=template&id=6d6dec00"
import script from "./ShowHuman.vue?vue&type=script&lang=js"
export * from "./ShowHuman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports